var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{on:{"reload":_vm.reload}}),(_vm.loadRouter)?_c('router-view',{staticClass:"router"}):_vm._e(),_c('BottomNavigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }